import React from 'react';
import Home from '../component/home/Home';

/**
 * Classic (legacy) UI entry. Wraps the existing Home page without modifying it so
 * the whole legacy tree can be removed by deleting this folder and its route.
 */
const LegacyHome: React.FC = () => <Home />;

export default LegacyHome;
